// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Sign/Register/Register.css */

.email-form-title{
    color: #EF6F53;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    width: 100%;
    display: block;
    text-transform: uppercase;
}

.email-input{
    width: 100%;
    padding: 2px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    transition: all 0.3s ease;
    text-align: center;
}

.email-input:focus{
    border-color: #EF6F53;
    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.2);
    outline: none;
}

.submit-email-button{
    width: 30%;
    padding: 0.1rem;
    background-color: #EF6F53;
    border: 1px solid #EF6F53;
    color: white;
    border-radius: 10px;
    cursor: pointer;
    margin-top: 1rem;
}   

.submit-email-button:hover{
    background-color: transparent;
    color: #EF6F53;
    border: 1px solid #EF6F53;
    font-weight: bold;
    cursor: pointer;
}


/* Readonly field styles */
.readonly-field {
    background-color: #f5f5f5;
    color: #666;
    cursor: not-allowed;
    border: 1px solid #ddd;
}

.readonly-field:focus {
    outline: none;
    box-shadow: none;
}

/* Form row styles */
.form-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
}

.form-row .form-grouppp {
    flex: 1 1;
    margin-top: 0;
}

/* Form group styles */
.form-grouppp {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    position: relative;
}

/* Password validation message */
.password-validation {
    font-size: 12px;
    margin-top: 4px;
    transition: all 0.3s ease;
}

.password-validation.valid {
    color: #28a745;
}

.password-validation.invalid {
    color: #dc3545;
}

.form-grouppp label {
    font-size: 14px;
    color: #333;
    margin-bottom: 0.5rem;
}

.form-grouppp input,
.form-grouppp select {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.form-grouppp input:focus,
.form-grouppp select:focus {
    border-color: #EF6F53;
    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.2);
    outline: none;
}

.form-grouppp input[type="password"] {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* Readonly field styles */
.form-grouppp .readonly-field {
    background-color: #f5f5f5;
    color: #666;
    cursor: not-allowed;
    border: 1px solid #ddd;
}

.form-grouppp .readonly-field:focus {
    border-color: #ddd;
    box-shadow: none;
}

.register-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
    background-color: white;
    border-radius: 10px;
    margin: 3rem auto;
    max-width: 100%;
}

.register-headi {
    color: #EF6F53;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 2rem;
    width: 100%;
    display: block;
    text-transform: uppercase;
}

.register-headi :focus {
    color: #d15846;
}

.register-left {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: all 0.3s ease;
}

.form-imppp{
    display: flex;
    gap: 20px;
}

.form-imp-1, .form-imp-2 {
    flex: 1 1;
    min-width: 45%;
}

.form-grouppp {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
    position: relative;
}

.otp-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding: 2rem;
}

.otp-input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.otp-boxes {
    display: flex;
    gap: 0.5rem;
}

.otp-box {
    width: 40px;
    height: 40px;
    border: 2px solid #ccc;
    border-radius: 8px;
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
    transition: all 0.3s ease;
}

.otp-box:focus {
    border-color: #EF6F53;
    outline: none;
    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.2);
}

.otp-timer {
    color: #666;
    font-size: 0.9rem;
}

.otp-actions {
    display: flex;
    gap: 1rem;
}

.verify-btn, .resend-btn {
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.verify-btn {
    background-color: #EF6F53;
    color: white;
}

.verify-btn:hover {
    background-color: #d15846;
}

.verify-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.resend-btn {
    background-color: #f0f0f0;
    color: #333;
}

.resend-btn:hover {
    background-color: #e0e0e0;
}

.resend-btn:disabled {
    background-color: #f0f0f0;
    color: #999;
    cursor: not-allowed;
}

.otp-attempts {
    color: #666;
    font-size: 0.9rem;
    margin-top: 0.5rem;
}

.form-grouppp label {
    font-size: 0.9rem;
    color: #364C63;
    font-weight: 600;
    text-align: left;
    margin-left: 0.25rem;
}

.form-grouppp input,
.form-grouppp textarea,
.form-grouppp select {
    width: 100%;
    padding: 0.2rem;
    font-size: 0.9rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    outline: none;
    transition: all 0.3s ease;
    background-color: #f8f9fa;
}

.form-grouppp input:focus,
.form-grouppp textarea:focus,
.form-grouppp select:focus {
    border-color: #EF6F53;
    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.1);
    background-color: white;
}

.form-grouppp textarea {
    min-height: 60px;
    resize: vertical;
}

.form-grouppp select {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 0.7rem center;
    background-size: 1em;
}

.register-left input:focus {
    border-color: #EF6F53;
}

.register-left button {
    background-color: #EF6F53;
    color: white;
    border: none;
    width: 30%;
    margin: auto;
    padding: 0.25rem;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(239, 111, 83, 0.2);
}

.register-left button:hover {
    background-color: #d15846;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(239, 111, 83, 0.3);
}

.register-left button:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(239, 111, 83, 0.2);
}

.logis{
    display: flex;
    margin: auto;
}

.head2 {
    color: #364C63;
    text-align: center;
    font-size: 0.9rem;
}

.login-link {
    display: inline-block;
    margin-top: 0.5rem;
    color: #EF6F53;
    font-weight: bold;
    text-decoration: none;
}

.login-link:hover {
    text-decoration: underline;
}

.register-right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.register-icon {
    width: 100%;
    max-width: 20rem;
    border-radius: 5px;
    margin-left: 10%;
}

.password-requirements {
    margin-top: 0.5rem;
    font-size: 0.85rem;
}

.password-requirements ul {
    list-style: none;
    padding-left: 0.5rem;
    margin-top: 0.25rem;
}

.password-requirements li {
    margin: 0.25rem 0;
}

/* Add red asterisk for required fields */
label[for="password"]::after,
label[for="confirm_password"]::after {
    content: " *";
    color: red;
}

/* Style for invalid password field */
input[type="password"]:invalid {
    border-color: #dc3545;
}

/* Style for valid password field */
input[type="password"]:valid {
    border-color: #28a745;
}

/* OTP Input Styles */
.otp-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    width: 100%;
    max-width: 400px;
    margin: 2rem auto;
    padding: 1rem;
}

.otp-heading {
    font-size: 24px;
    font-weight: 600;
    color: #364C63;
    margin-bottom: 2rem;
    text-align: center;
    width: 100%;
    display: block;
}

.otp-inputs {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
}

.otp-input {
    width: 3rem;
    height: 3rem;
    font-size: 1.5rem;
    text-align: center;
    border: 2px solid #ddd;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
}

.otp-input:focus {
    border-color: #EF6F53;
    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.1);
    background-color: white;
    outline: none;
}

.otp-timer {
    font-size: 0.9rem;
    color: #364C63;
    margin-top: 1rem;
}

.otp-label {
    font-size: 1rem;
    color: #364C63;
    font-weight: 500;
    text-align: center;
    margin-bottom: 1rem;
}

.resend-button {
    background: none;
    border: none;
    color: #EF6F53;
    font-size: 0.9rem;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
}

.resend-button:disabled {
    color: #999;
    cursor: not-allowed;
    text-decoration: none;
    margin: 2rem auto;
}

.otp-input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    width: 100%;
}

.otp-boxes {
    display: flex;
    justify-content: center;
    gap: 12px;
    width: 100%;
}

.otp-boxes input {
    width: 45px;
    height: 45px;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    border: 2px solid #ddd;
    border-radius: 8px;
    background: white;
    transition: all 0.3s ease;
    padding: 0;
    margin: 0;
    caret-color: #007bff;
}

.otp-boxes input:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
    transform: scale(1.05);
}

.otp-boxes input:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
}

.otp-timer {
    color: #666;
    font-size: 0.9rem;
    margin-top: 1rem;
    text-align: center;
}

.otp-actions {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 1rem;
}

.verify-btn, .resend-btn {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 150px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.verify-btn {
    background-color: #007bff;
    color: white;
    box-shadow: 0 2px 4px rgba(0,123,255,0.2);
}

.verify-btn:hover:not(:disabled) {
    background-color: #0056b3;
    box-shadow: 0 4px 8px rgba(0,123,255,0.3);
    transform: translateY(-1px);
}

.resend-btn {
    background-color: #6c757d;
    color: white;
    box-shadow: 0 2px 4px rgba(108,117,125,0.2);
}

.resend-btn:hover:not(:disabled) {
    background-color: #5a6268;
    box-shadow: 0 4px 8px rgba(108,117,125,0.3);
    transform: translateY(-1px);
}

.verify-btn:disabled, .resend-btn:disabled {
    background-color: #e9ecef;
    color: #adb5bd;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
}

.verify-btn:active, .resend-btn:active {
    transform: translateY(1px);
    box-shadow: none;
}

.otp-attempts {
    color: #dc3545;
    font-size: 0.9rem;
    margin-top: 0.5rem;
    text-align: center;
}

/* Responsive Design */
@media screen and (width: 1260px) and (height: 590px) {
    .register-container {
        height: 85vh;
        padding: 0.5rem;
        gap: 1rem;
    }

    .register-left {
        width: 65%;
        padding: 1rem;
        margin: 0;
    }

    .register-right {
        width: 25%;
    }

    .form-imppp {
        gap: 1.5rem;
    }

    .form-grouppp {
        margin-bottom: 0.4rem;
    }

    .form-grouppp input,
    .form-grouppp textarea,
    .form-grouppp select {
        padding: 0.15rem;
        font-size: 0.85rem;
    }

    .form-grouppp label {
        font-size: 0.85rem;
        margin-bottom: 0.2rem;
    }

    .form-grouppp textarea {
        min-height: 60px;
    }

    .register-left button {
        padding: 0.2rem;
        margin-top: 0.5rem;
        width: 25%;
    }

    .logis {
        margin-top: 0.3rem;
    }

    .head2 {
        font-size: 0.85rem;
        margin-right: 0.3rem;
    }

    .login-link {
        margin-top: 0.3rem;
        font-size: 0.85rem;
    }

    .register-icon {
        max-width: 15rem;
    }
}

@media (max-width: 1024px) {
    .register-left {
        width: 75%;
        margin: 1rem;
    }
}

@media (max-width: 768px) {
    .register-container {
        flex-direction: column-reverse;
        height: auto;
        padding: 1rem;
    }

    .register-left {
        width: 90%;
        margin: 1rem auto;
        padding: 1.5rem;
    }

    .form-imppp {
        flex-direction: column;
        gap: 0;
    }

    .form-imp-1, .form-imp-2 {
        width: 100%;
    }

    .form-imp-2 {
        margin-left: 0;
    }

    .register-left button {
        width: 60%;
    }
}

@media (max-width: 480px) {
    .register-left {
        width: 100%;
        padding: 1rem;
    }

    .form-grouppp input,
    .form-grouppp textarea,
    .form-grouppp select {
        padding: 0.5rem;
    }

    .register-left button {
        width: 80%;
    }

    .otp-boxes {
        gap: 8px;
    }

    .otp-boxes input {
        width: 40px;
        height: 40px;
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/Register/Register.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;;AAGA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,wIAAwI;AAC5I;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;IACrB,6CAA6C;IAC7C,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yDAA2R;IAC3R,4BAA4B;IAC5B,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,yCAAyC;AACzC;;IAEI,aAAa;IACb,UAAU;AACd;;AAEA,qCAAqC;AACrC;IACI,qBAAqB;AACzB;;AAEA,mCAAmC;AACnC;IACI,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;IACV,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,0CAA0C;IAC1C,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;QACZ,eAAe;QACf,SAAS;IACb;;IAEA;QACI,UAAU;QACV,aAAa;QACb,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;;QAGI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,MAAM;IACV;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":["/* src/components/routes/Sign/Register/Register.css */\n\n.email-form-title{\n    color: #EF6F53;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    width: 100%;\n    display: block;\n    text-transform: uppercase;\n}\n\n.email-input{\n    width: 100%;\n    padding: 2px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    transition: all 0.3s ease;\n    text-align: center;\n}\n\n.email-input:focus{\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.2);\n    outline: none;\n}\n\n.submit-email-button{\n    width: 30%;\n    padding: 0.1rem;\n    background-color: #EF6F53;\n    border: 1px solid #EF6F53;\n    color: white;\n    border-radius: 10px;\n    cursor: pointer;\n    margin-top: 1rem;\n}   \n\n.submit-email-button:hover{\n    background-color: transparent;\n    color: #EF6F53;\n    border: 1px solid #EF6F53;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n\n/* Readonly field styles */\n.readonly-field {\n    background-color: #f5f5f5;\n    color: #666;\n    cursor: not-allowed;\n    border: 1px solid #ddd;\n}\n\n.readonly-field:focus {\n    outline: none;\n    box-shadow: none;\n}\n\n/* Form row styles */\n.form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.form-row .form-grouppp {\n    flex: 1;\n    margin-top: 0;\n}\n\n/* Form group styles */\n.form-grouppp {\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n    position: relative;\n}\n\n/* Password validation message */\n.password-validation {\n    font-size: 12px;\n    margin-top: 4px;\n    transition: all 0.3s ease;\n}\n\n.password-validation.valid {\n    color: #28a745;\n}\n\n.password-validation.invalid {\n    color: #dc3545;\n}\n\n.form-grouppp label {\n    font-size: 14px;\n    color: #333;\n    margin-bottom: 0.5rem;\n}\n\n.form-grouppp input,\n.form-grouppp select {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    transition: all 0.3s ease;\n}\n\n.form-grouppp input:focus,\n.form-grouppp select:focus {\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.2);\n    outline: none;\n}\n\n.form-grouppp input[type=\"password\"] {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Readonly field styles */\n.form-grouppp .readonly-field {\n    background-color: #f5f5f5;\n    color: #666;\n    cursor: not-allowed;\n    border: 1px solid #ddd;\n}\n\n.form-grouppp .readonly-field:focus {\n    border-color: #ddd;\n    box-shadow: none;\n}\n\n.register-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 75vh;\n    background-color: white;\n    border-radius: 10px;\n    margin: 3rem auto;\n    max-width: 100%;\n}\n\n.register-headi {\n    color: #EF6F53;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 2rem;\n    width: 100%;\n    display: block;\n    text-transform: uppercase;\n}\n\n.register-headi :focus {\n    color: #d15846;\n}\n\n.register-left {\n    width: 60%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    transition: all 0.3s ease;\n}\n\n.form-imppp{\n    display: flex;\n    gap: 20px;\n}\n\n.form-imp-1, .form-imp-2 {\n    flex: 1;\n    min-width: 45%;\n}\n\n.form-grouppp {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0.5rem;\n    position: relative;\n}\n\n.otp-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n    padding: 2rem;\n}\n\n.otp-input-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n}\n\n.otp-boxes {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.otp-box {\n    width: 40px;\n    height: 40px;\n    border: 2px solid #ccc;\n    border-radius: 8px;\n    text-align: center;\n    font-size: 1.2rem;\n    font-weight: bold;\n    transition: all 0.3s ease;\n}\n\n.otp-box:focus {\n    border-color: #EF6F53;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.2);\n}\n\n.otp-timer {\n    color: #666;\n    font-size: 0.9rem;\n}\n\n.otp-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.verify-btn, .resend-btn {\n    padding: 0.5rem 1.5rem;\n    border: none;\n    border-radius: 4px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.verify-btn {\n    background-color: #EF6F53;\n    color: white;\n}\n\n.verify-btn:hover {\n    background-color: #d15846;\n}\n\n.verify-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.resend-btn {\n    background-color: #f0f0f0;\n    color: #333;\n}\n\n.resend-btn:hover {\n    background-color: #e0e0e0;\n}\n\n.resend-btn:disabled {\n    background-color: #f0f0f0;\n    color: #999;\n    cursor: not-allowed;\n}\n\n.otp-attempts {\n    color: #666;\n    font-size: 0.9rem;\n    margin-top: 0.5rem;\n}\n\n.form-grouppp label {\n    font-size: 0.9rem;\n    color: #364C63;\n    font-weight: 600;\n    text-align: left;\n    margin-left: 0.25rem;\n}\n\n.form-grouppp input,\n.form-grouppp textarea,\n.form-grouppp select {\n    width: 100%;\n    padding: 0.2rem;\n    font-size: 0.9rem;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    outline: none;\n    transition: all 0.3s ease;\n    background-color: #f8f9fa;\n}\n\n.form-grouppp input:focus,\n.form-grouppp textarea:focus,\n.form-grouppp select:focus {\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.1);\n    background-color: white;\n}\n\n.form-grouppp textarea {\n    min-height: 60px;\n    resize: vertical;\n}\n\n.form-grouppp select {\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 0.7rem center;\n    background-size: 1em;\n}\n\n.register-left input:focus {\n    border-color: #EF6F53;\n}\n\n.register-left button {\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    width: 30%;\n    margin: auto;\n    padding: 0.25rem;\n    font-size: 1rem;\n    font-weight: 500;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 4px rgba(239, 111, 83, 0.2);\n}\n\n.register-left button:hover {\n    background-color: #d15846;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(239, 111, 83, 0.3);\n}\n\n.register-left button:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(239, 111, 83, 0.2);\n}\n\n.logis{\n    display: flex;\n    margin: auto;\n}\n\n.head2 {\n    color: #364C63;\n    text-align: center;\n    font-size: 0.9rem;\n}\n\n.login-link {\n    display: inline-block;\n    margin-top: 0.5rem;\n    color: #EF6F53;\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.login-link:hover {\n    text-decoration: underline;\n}\n\n.register-right {\n    width: 30%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.register-icon {\n    width: 100%;\n    max-width: 20rem;\n    border-radius: 5px;\n    margin-left: 10%;\n}\n\n.password-requirements {\n    margin-top: 0.5rem;\n    font-size: 0.85rem;\n}\n\n.password-requirements ul {\n    list-style: none;\n    padding-left: 0.5rem;\n    margin-top: 0.25rem;\n}\n\n.password-requirements li {\n    margin: 0.25rem 0;\n}\n\n/* Add red asterisk for required fields */\nlabel[for=\"password\"]::after,\nlabel[for=\"confirm_password\"]::after {\n    content: \" *\";\n    color: red;\n}\n\n/* Style for invalid password field */\ninput[type=\"password\"]:invalid {\n    border-color: #dc3545;\n}\n\n/* Style for valid password field */\ninput[type=\"password\"]:valid {\n    border-color: #28a745;\n}\n\n/* OTP Input Styles */\n.otp-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n    width: 100%;\n    max-width: 400px;\n    margin: 2rem auto;\n    padding: 1rem;\n}\n\n.otp-heading {\n    font-size: 24px;\n    font-weight: 600;\n    color: #364C63;\n    margin-bottom: 2rem;\n    text-align: center;\n    width: 100%;\n    display: block;\n}\n\n.otp-inputs {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: center;\n}\n\n.otp-input {\n    width: 3rem;\n    height: 3rem;\n    font-size: 1.5rem;\n    text-align: center;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    background-color: #f8f9fa;\n    transition: all 0.3s ease;\n}\n\n.otp-input:focus {\n    border-color: #EF6F53;\n    box-shadow: 0 0 0 2px rgba(239, 111, 83, 0.1);\n    background-color: white;\n    outline: none;\n}\n\n.otp-timer {\n    font-size: 0.9rem;\n    color: #364C63;\n    margin-top: 1rem;\n}\n\n.otp-label {\n    font-size: 1rem;\n    color: #364C63;\n    font-weight: 500;\n    text-align: center;\n    margin-bottom: 1rem;\n}\n\n.resend-button {\n    background: none;\n    border: none;\n    color: #EF6F53;\n    font-size: 0.9rem;\n    cursor: pointer;\n    text-decoration: underline;\n    padding: 0;\n}\n\n.resend-button:disabled {\n    color: #999;\n    cursor: not-allowed;\n    text-decoration: none;\n    margin: 2rem auto;\n}\n\n.otp-input-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    width: 100%;\n}\n\n.otp-boxes {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    width: 100%;\n}\n\n.otp-boxes input {\n    width: 45px;\n    height: 45px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: center;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    background: white;\n    transition: all 0.3s ease;\n    padding: 0;\n    margin: 0;\n    caret-color: #007bff;\n}\n\n.otp-boxes input:focus {\n    border-color: #007bff;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n    transform: scale(1.05);\n}\n\n.otp-boxes input:disabled {\n    background-color: #f8f9fa;\n    cursor: not-allowed;\n}\n\n.otp-timer {\n    color: #666;\n    font-size: 0.9rem;\n    margin-top: 1rem;\n    text-align: center;\n}\n\n.otp-actions {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin-top: 1rem;\n}\n\n.verify-btn, .resend-btn {\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 150px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.verify-btn {\n    background-color: #007bff;\n    color: white;\n    box-shadow: 0 2px 4px rgba(0,123,255,0.2);\n}\n\n.verify-btn:hover:not(:disabled) {\n    background-color: #0056b3;\n    box-shadow: 0 4px 8px rgba(0,123,255,0.3);\n    transform: translateY(-1px);\n}\n\n.resend-btn {\n    background-color: #6c757d;\n    color: white;\n    box-shadow: 0 2px 4px rgba(108,117,125,0.2);\n}\n\n.resend-btn:hover:not(:disabled) {\n    background-color: #5a6268;\n    box-shadow: 0 4px 8px rgba(108,117,125,0.3);\n    transform: translateY(-1px);\n}\n\n.verify-btn:disabled, .resend-btn:disabled {\n    background-color: #e9ecef;\n    color: #adb5bd;\n    cursor: not-allowed;\n    box-shadow: none;\n    transform: none;\n}\n\n.verify-btn:active, .resend-btn:active {\n    transform: translateY(1px);\n    box-shadow: none;\n}\n\n.otp-attempts {\n    color: #dc3545;\n    font-size: 0.9rem;\n    margin-top: 0.5rem;\n    text-align: center;\n}\n\n/* Responsive Design */\n@media screen and (width: 1260px) and (height: 590px) {\n    .register-container {\n        height: 85vh;\n        padding: 0.5rem;\n        gap: 1rem;\n    }\n\n    .register-left {\n        width: 65%;\n        padding: 1rem;\n        margin: 0;\n    }\n\n    .register-right {\n        width: 25%;\n    }\n\n    .form-imppp {\n        gap: 1.5rem;\n    }\n\n    .form-grouppp {\n        margin-bottom: 0.4rem;\n    }\n\n    .form-grouppp input,\n    .form-grouppp textarea,\n    .form-grouppp select {\n        padding: 0.15rem;\n        font-size: 0.85rem;\n    }\n\n    .form-grouppp label {\n        font-size: 0.85rem;\n        margin-bottom: 0.2rem;\n    }\n\n    .form-grouppp textarea {\n        min-height: 60px;\n    }\n\n    .register-left button {\n        padding: 0.2rem;\n        margin-top: 0.5rem;\n        width: 25%;\n    }\n\n    .logis {\n        margin-top: 0.3rem;\n    }\n\n    .head2 {\n        font-size: 0.85rem;\n        margin-right: 0.3rem;\n    }\n\n    .login-link {\n        margin-top: 0.3rem;\n        font-size: 0.85rem;\n    }\n\n    .register-icon {\n        max-width: 15rem;\n    }\n}\n\n@media (max-width: 1024px) {\n    .register-left {\n        width: 75%;\n        margin: 1rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .register-container {\n        flex-direction: column-reverse;\n        height: auto;\n        padding: 1rem;\n    }\n\n    .register-left {\n        width: 90%;\n        margin: 1rem auto;\n        padding: 1.5rem;\n    }\n\n    .form-imppp {\n        flex-direction: column;\n        gap: 0;\n    }\n\n    .form-imp-1, .form-imp-2 {\n        width: 100%;\n    }\n\n    .form-imp-2 {\n        margin-left: 0;\n    }\n\n    .register-left button {\n        width: 60%;\n    }\n}\n\n@media (max-width: 480px) {\n    .register-left {\n        width: 100%;\n        padding: 1rem;\n    }\n\n    .form-grouppp input,\n    .form-grouppp textarea,\n    .form-grouppp select {\n        padding: 0.5rem;\n    }\n\n    .register-left button {\n        width: 80%;\n    }\n\n    .otp-boxes {\n        gap: 8px;\n    }\n\n    .otp-boxes input {\n        width: 40px;\n        height: 40px;\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
